import { jsxs as a, jsx as t } from "react/jsx-runtime";
import { useState as c, useEffect as C } from "react";
import { useDropzone as k } from "react-dropzone";
import { useTranslation as g } from "react-i18next";
import y from "classnames";
import f from "../../components/Button/index.js";
import F from "../../icons/Close.js";
import { filesIcons as n } from "../../data/mock.js";
const w = "forma-ui__file-input__buttons", L = "forma-ui__file-input__button", P = "forma-ui__file-input__file", S = "forma-ui__file-input__fileName", j = "forma-ui__file-input__fileIcon", z = "forma-ui__file-input__remove", D = "forma-ui__file-input__removeIcon", o = {
  buttons: w,
  button: L,
  file: P,
  fileName: S,
  fileIcon: j,
  remove: z,
  removeIcon: D
}, G = ({
  accept: u,
  onChange: _,
  className: p
}) => {
  const { t: l } = g(), [d, v] = c(!1), [e, r] = c(null), { getRootProps: I, getInputProps: N, open: h } = k({
    maxFiles: 1,
    noClick: !0,
    accept: u,
    onDrop: (s) => r(s[0])
  });
  C(() => {
    d ? _(e) : v(!0);
  }, [e]);
  const x = () => {
    r(null);
  }, m = e == null ? void 0 : e.name.lastIndexOf("."), b = e == null ? void 0 : e.name.slice(0, m), i = e == null ? void 0 : e.name.slice(m).toLowerCase();
  return /* @__PURE__ */ a("div", { className: y(o.root, e && o.filled, p), ...I(), children: [
    /* @__PURE__ */ t("input", { ...N() }),
    e ? /* @__PURE__ */ t("div", { className: o.files, children: /* @__PURE__ */ a("div", { className: o.file, children: [
      /* @__PURE__ */ t("img", { src: i && n[i] ? n[i] : n.other, className: o.fileIcon, alt: i }),
      /* @__PURE__ */ t("div", { className: o.fileName, children: b }),
      /* @__PURE__ */ t(
        f,
        {
          className: o.remove,
          viewStyle: "text",
          iconClassName: o.removeIcon,
          icon: /* @__PURE__ */ t(F, {}),
          onClick: () => x(),
          title: l("uikit:delete")
        }
      )
    ] }) }) : /* @__PURE__ */ t("div", { className: o.buttons, children: /* @__PURE__ */ t(
      f,
      {
        className: o.button,
        viewStyle: "tertiary",
        size: "small",
        onClick: (s) => {
          s.stopPropagation(), h();
        },
        children: l("uikit:select_file")
      }
    ) })
  ] });
};
export {
  G as default
};
